import Grid from '@mui/material/Grid';

import NotesFormField from 'reservations/form/components/NotesFormField';
import SpecialOccasionFormField from 'reservations/form/components/SpecialOccasionFormField';

export const BookingFields = () => {
  return (
    <>
      <Grid item>
        <SpecialOccasionFormField />
      </Grid>
      <Grid item>
        <NotesFormField />
      </Grid>
    </>
  );
};
